var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canDisplayDetails
    ? _c("BreakDetails", {
        scopedSlots: _vm._u(
          [
            {
              key: "breakDetails",
              fn: function () {
                return [
                  _vm.formattedRestBreakTimes
                    ? _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "jest",
                              rawName: "v-jest",
                              value: "rest-break-details",
                              expression: "'rest-break-details'",
                            },
                            {
                              name: "data-cy",
                              rawName: "v-data-cy",
                              value: "rest-break-details",
                              expression: "'rest-break-details'",
                            },
                          ],
                          staticClass: "tw-mt-4",
                        },
                        [
                          _vm._v(
                            "\n\t\t\tRest break at " +
                              _vm._s(_vm.formattedRestBreakTimes.startTime) +
                              " to " +
                              _vm._s(_vm.formattedRestBreakTimes.endTime) +
                              "\n\t\t"
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1410977201
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }